import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useRequestBindEmail } from "../../hooks/useRequestBindEmail";
import LoadingCrmData from "../LoadingCrmData";
import { ContactSelectSuccess } from "../../pages/ContactSelect/ContactSelectSuccess";
import ContactSearchBox from "./ContactSearchBox";
import EmailRewriteOptions from "./EmailRewriteOptions";
import { ContactDetails, ZohoContact } from "../../types/zoho";
import axios from "axios";
import { LAMBDA_BASE_URL } from "../../constants";
import { LoadingButton } from "@mui/lab";

interface Props {
  onSuccess: (contactDetails: ContactDetails) => void;
}

export function FindContact({ onSuccess }: Props) {
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState<string>("primary");
  const [isLoading, setIsLoading] = useState(false);
  const [errorOnUpdate, setErrorOnUpdate] = useState<string | null>(null);
  const queryParams = new URLSearchParams(location.search);
  const fullName = queryParams.get("fullName");
  const email = queryParams.get("email");
  const [existingContact, setExistingContact] = useState<ZohoContact | null>(
    null
  );

  const { loading, contactData } = useRequestBindEmail();

  const assignAccount = async () => {
    const data: any = {
      id: existingContact?.id,
    };
    if (selectedOption === "primary") {
      data.email = email;
    } else {
      data.secondaryEmail = email;
    }
    try {
      setErrorOnUpdate(null);
      setIsLoading(true);
      await axios.post<any>(LAMBDA_BASE_URL, data, {
        data,
        params: {
          isUpdate: true,
        },
      });
      setIsLoading(false);
      onSuccess({
        fullName: existingContact?.fullName!,
        account: existingContact?.account!,
      });
    } catch (error) {
      setIsLoading(false);
      setErrorOnUpdate(
        "Something went wrong while updating the contact. Please try again later."
      );
      console.error("Error fetching search results:", error);
    }
  };

  return (
    <>
      {!loading && !contactData && (
        <Box sx={{ mt: 3 }}>
          <ContactSearchBox
            setContact={setExistingContact}
            initialValue={fullName?.trim() ?? email?.trim() ?? ""}
          />
          {existingContact && (
            <Box sx={{ mt: 2, width: "100%" }}>
              <EmailRewriteOptions
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                primaryEmail={existingContact.email}
                secondaryEmail={""}
                newEmail={email!}
              />
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}>
            <LoadingButton
              loading={isLoading}
              sx={{ marginTop: 4, width: "100%" }}
              variant='contained'
              size='large'
              onClick={assignAccount}
              disabled={existingContact === null}>
              Confirm
            </LoadingButton>
          </Box>
          {errorOnUpdate && (
            <Typography variant='body1' color='error' mt='8px'>
              {errorOnUpdate}
            </Typography>
          )}
        </Box>
      )}
      {loading && <LoadingCrmData />}
      {!loading && contactData && <ContactSelectSuccess {...contactData} />}
    </>
  );
}
